/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Info about last months winners (derived from winner record documents).
 * @export
 * @interface WinnerSummary
 */
export interface WinnerSummary {
    /**
     * Name of the winner (user name or guild name if entire guild won)
     * @type {string}
     * @memberof WinnerSummary
     */
    winnerName: string;
    /**
     * Brand name to display on guild page
     * @type {string}
     * @memberof WinnerSummary
     */
    rewardDescription: string;
}

export function WinnerSummaryFromJSON(json: any): WinnerSummary {
    return WinnerSummaryFromJSONTyped(json, false);
}

export function WinnerSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): WinnerSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'winnerName': json['winnerName'],
        'rewardDescription': json['rewardDescription'],
    };
}

export function WinnerSummaryToJSON(value?: WinnerSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'winnerName': value.winnerName,
        'rewardDescription': value.rewardDescription,
    };
}


